<template>
    <f7-page id="account-update-detail" name="account-update-detail" @page:afterin="afterin" @page:beforein="beforein" @page:reinit="reinit">
        <f7-navbar class="view-mobile">
            <f7-nav-left class="back-button">
                <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
            </f7-nav-left>
            <f7-nav-right></f7-nav-right>
        </f7-navbar>
        <div class="block">
            <div class="fw-bold fs-24 mb-md">{{ tempUpdateAccountType == 2 ? $t('ua-edit-phone-number') : $t('ua-edit-email') }}</div>
            <f7-list form class="form-group">
                <InputEmail
                    v-if="tempUpdateAccountType == 1"
                    name="newEmail"
                    :label="$t('ua-new-email')"
                    theValue="update.tempNewEmail"
                    @validateInput="validateEmailInput"
                    :key="newEmailKey"
                />

                <InputEmail
                    v-if="tempUpdateAccountType == 1"
                    name="confirmEmail"
                    :label="$t('ua-confirm-new-email')"
                    theValue="update.tempConfirmNewEmail"
                    @validateInput="validateEmailInput"
                    :key="confirmEmailKey"
                />

                <InputMobilePhone
                    v-if="tempUpdateAccountType == 2"
                    listId="mobileNoListId"
                    linkId="accountMobileCountryCode"
                    name="mobileNo"
                    popoverDropdown="accountMobileNoDropdown"
                    searchbarId="accMobileCountryCodeSearch"
                    :label="$t('general-text-phone-number')"
                    :countryList="countryList"
                    @validateInput="validateMobileInput"
                />

                <InputMobilePhone
                    v-if="tempUpdateAccountType == 2"
                    listId="newMobileNoListId"
                    linkId="accountNewMobileCountryCode"
                    name="newMobileNo"
                    popoverDropdown="accountNewMobileNoDropdown"
                    searchbarId="accNewMobileCountryCodeSearch"
                    :label="$t('ua-new-phone-number')"
                    :countryList="countryList"
                    @validateInput="validateMobileInput"
                />

            </f7-list>

            <f7-button round large fill @click="submitForm" class="mt-5 view-desktop" :disabled="!isNextButtonValid">{{$t('general-text-confirm')}}</f7-button>
        </div>

        <f7-toolbar position="bottom" no-hairline class="toolbar-with-button view-mobile">
            <f7-button large fill @click="submitForm" :disabled="!isNextButtonValid">
                {{$t('general-text-confirm')}}
            </f7-button>
        </f7-toolbar>
    </f7-page>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import InputMobilePhone from '../../components/account-mobile-phone.vue';
    import InputEmail from '../../components/account-email.vue';
    //import store from '../../store';

    export default {
        props: {
            type: Number,
            data: Object,
        },
        data() {
            return {
                countryList         : [],
                emailValidation     : {email: false, newEmail: false, confirmEmail: false},
                mobileValidation    : {mobileNo: false, newMobileNo: false},
                isNextButtonValid   : false,

                email               : "",
                newEmail            : "",
                confirmEmail        : "",
                token               : "",

                mobileCountryId     : 0,
                mobileCountryIdCode : "",
                mobileNo            : "",
                newMobileCountryId  : 0,
                newMobileCountryIdCode  : "",
                newMobileNo         : "",

                isTypeChanged       : false,
                newEmailKey         : 0,
                confirmEmailKey     : 1000,
            }
        },
        mounted (){
            //console.log("mounted edit details: ", this.tempUpdateAccountData)
            this.token = this.tempUpdateAccountData != undefined ? this.tempUpdateAccountData.token : "";
            if(this.tempUpdateAccountType == 1) {
                this.email = this.tempUpdateAccountData != undefined ? this.tempUpdateAccountData.email : "";
                const passReq = this.tempUpdateAccountData != undefined && this.tempUpdateAccountData.passReq;
                this.emailValidation.email = (passReq || this.token != '');

                this.newEmailKey += 1;
                this.confirmEmailKey += 1;
            } else if(this.tempUpdateAccountType == 2) {
                this.getCountryList();
            }

            this.init();
        },
        methods: {
            ...mapActions('auth', ['login']),
            ...mapActions('customer', ['setTempUpdateAccountType', 'setTempUpdateAccountData']),
            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },

            beforein(){
                //console.log("beforein : "+this.tempUpdateAccountType)
            },

            reinit(){
                console.log("re-init")
                location.reload();
            },

            init(){
                const self    = this;

                const popover = ".account.popover-mobileNo";
                const popoverInner = ".account.popover-mobileNo .popover-inner";
                const popoverId = "accountMobileNoDropdown";
                const inputId = "mobileNo";
                const inputListId = "#mobileNoListId";

                self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId, "mobile-input", "accountMobileCountryCode", "accMobileCountryCodeSearch")

                const popover2 = ".account.popover-newMobileNo";
                const popoverInner2 = ".account.popover-newMobileNo .popover-inner";
                const popoverId2 = "accountNewMobileNoDropdown";
                const inputId2 = "newMobileNo";
                const inputListId2 = "#newMobileNoListId";

                self.setDropdownDirection(popover2, popoverInner2, popoverId2, inputId2, inputListId2, "mobile-input", "accountNewMobileCountryCode", "accNewMobileCountryCodeSearch")
            },

            async getCountryList() {
                const self = this;
                self.showPreloader();
                self.$api.staticData.getCountryList().then(function(result) {
                    self.countryList = result.filter(country => country.isHidden == false);

                    self.countryList.forEach(function(item,i){
                        if(item.countryId === 189){
                          self.countryList.splice(i, 1);
                          self.countryList.unshift(item);
                        }
                    });

                    const sgCountry = self.countryList.filter(country => country.countryId == 189);
                    self.mobileCountryId = sgCountry.length>0?sgCountry[0].countryId:189;
                    self.mobileCountryIdCode = sgCountry.length>0?sgCountry[0].countryIDD:'+65';

                    self.newMobileCountryId = self.mobileCountryId;
                    self.newMobileCountryIdCode = self.mobileCountryIdCode;

                    self.hidePreloader();
                });
            },
            validateMobileInput(data) {
                if(data.name == 'mobileNo') {
                    this.mobileNo = data.mobileNo;
                    this.mobileCountryId = data.mobileCountryId;
                    this.mobileCountryIdCode = data.mobileCountryCode;
                    this.mobileValidation.mobileNo = data.isValidate;
                } else if(data.name == 'newMobileNo') {
                    this.newMobileNo = data.mobileNo;
                    this.newMobileCountryId = data.mobileCountryId;
                    this.newMobileCountryIdCode = data.mobileCountryCode;
                    this.mobileValidation.newMobileNo = data.isValidate;
                }

                this.isNextButtonValid = (this.mobileValidation.mobileNo && this.mobileValidation.newMobileNo);
            },
            validateEmailInput(data) {
                if(data.name == 'newEmail') {
                    this.newEmail = data.email;
                    this.emailValidation.newEmail = data.isValidate;
                    if(this.confirmEmail != '') {
                        this.emailValidation.confirmEmail = (this.newEmail == this.confirmEmail);
                    }
                } else if(data.name == 'confirmEmail') {
                    this.confirmEmail = data.email;
                    this.emailValidation.confirmEmail = (data.isValidate && this.newEmail == this.confirmEmail);
                }

                if(this.confirmEmail != '' && this.newEmail != this.confirmEmail && (data.name == "newEmail" || data.name == "confirmEmail")) {
                    this.setInputState('confirmEmail', this.$t('regis-email-rule'));
                } else if(data.name == "newEmail") {
                    this.setInputState('confirmEmail',true);
                }

                //console.log(this.emailValidation.email +" && "+ this.emailValidation.newEmail +" && "+ this.emailValidation.confirmEmail)

                this.isNextButtonValid = (this.emailValidation.email && this.emailValidation.newEmail && this.emailValidation.confirmEmail);
            },
            async submitForm() {
                //console.log("submitForm this.token : "+this.token)

                this.mobileCountryId = this.update.tempCurrMobileCountryCodeId
                this.mobileNo = this.update.tempCurrMobileNo
                this.newMobileCountryId = this.update.tempNewMobileCountryCodeId
                this.newMobileNo = this.update.tempNewMobileNo

                if(this.tempUpdateAccountType == 1 && this.token != '') { // edit email & using appleid
                    //this.showPreloader();
                    /*
                    try {
                        const result = await this.$api.customer.updateCustomerEmail('', this.token, this.email, this.newEmail);
                        this.hidePreloader();
                        if(result === undefined || result.length <= 0) {
                            this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                            return false;
                        }

                        this.$f7router.navigate("/account/email-verify");
                    } catch(e){
                        this.hidePreloader();
                        if(e.message.toLowerCase().includes("undefined")) {
                            this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                        } else {
                            this.$f7.dialog.alert(e.message);
                        }
                    }
                    */

                    this.checkUpdateAccountVerification(true, false, this.email, this.newEmail, '', '', '', '', this.token, '')
                } else if(this.tempUpdateAccountType == 1) { // edit email & not using appleid
                    //this.$f7router.navigate("/account/input-password", { transition: 'f7-push', props: { type: this.tempUpdateAccountType, data: {oldEmail: this.email, newEmail: this.newEmail} } });

                    this.checkUpdateAccountVerification(true, false, this.email, this.newEmail, '', '', '', '', '', '')
                } else if(this.tempUpdateAccountType == 2 && this.token != '') { // edit mobile no & using appleid
                    /*
                    this.showPreloader();
                    try {
                        var updateData = store.state.misc;
                        updateData.mobileCountryId = this.mobileCountryId;
                        updateData.mobileNo = this.mobileNo;
                        updateData.newMobileCountryId = this.newMobileCountryId;
                        updateData.newMobileNo = this.newMobileNo;
                        updateData.password = "";
                        updateData.appleToken = this.token;

                        const result = await this.$api.otp.requestotp(4);
                        this.hidePreloader();
                        if(result.status) {
                            updateData.otp.routerTo = 'editMobilePhone';
                            this.$f7router.navigate("/otp");
                        } else {
                            this.$f7.dialog.alert(result.message);
                        }
                    } catch(e){
                        this.hidePreloader();
                        if(e.message.toLowerCase().includes("undefined")) {
                            this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                        } else {
                            this.$f7.dialog.alert(e.message);
                        }
                    }
                    */


                    this.checkUpdateAccountVerification(false, true, '', '', this.mobileCountryId, this.mobileNo, this.newMobileCountryId, this.newMobileNo, this.token, '')
                } else if(this.tempUpdateAccountType == 2) { // edit mobile no & not using appleid
                    /*this.$f7router.navigate("/account/input-password", { transition: 'f7-push', props: { type: this.tempUpdateAccountType, data: {mobileCountryId: this.mobileCountryId, mobileNo: this.mobileNo, newMobileCountryId: this.newMobileCountryId, newMobileNo: this.newMobileNo} } });
                    */

                    this.checkUpdateAccountVerification(false, true, '', '', this.mobileCountryId, this.mobileNo, this.newMobileCountryId, this.newMobileNo, '', '')
                }
            },
            backButton() {
                //this.$f7router.back({ transition: 'f7-push' });
                this.$f7router.navigate("/account/my-details");
            }
        },
        components: {
            InputEmail,
            InputMobilePhone
        },
        computed: {
            ...mapGetters('auth', [
                'authenticating',
                'authenticationError',
                'authenticationErrorCode',
                'authenticationSuccess'
            ]),
            ...mapGetters('customer', [
                'update',
                'tempUpdateAccountType',
                'tempUpdateAccountData'
            ]),
        },

        watch: {
            tempUpdateAccountType(newValue, oldValue) {
              //console.log(`Updating from ${oldValue} to ${newValue}`);

              if(!this.isTypeChanged && (oldValue !== newValue)){
                this.setTempUpdateAccountType(oldValue)
                this.isTypeChanged = true
                //console.log("updated val : "+this.tempUpdateAccountType)
              }
              
            },
        },
    }
</script>